import {
  GET_ALL_SUMMARIES_DASHBOARD_DATA,
  GET_ALL_SUMMARIES_DASHBOARD_DATA_ERROR,
  GET_ALL_SUMMARIES_DASHBOARD_DATA_SUCCESS
} from "../actions/adminDashboardAction";

const initialState = {
  allSummariesData: [],
  allSummariesLoading: false,
  allSummariesLoaded: false,
  allSummariesError: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_SUMMARIES_DASHBOARD_DATA:
      return {
        ...state,
        allSummariesLoading: true,
        allSummariesLoaded: false,
        error: null,
      };

    case GET_ALL_SUMMARIES_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        allSummariesLoading: false,
        allSummariesLoaded: true,
        allSummariesData: action.payload.success,
      };

    case GET_ALL_SUMMARIES_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        allSummariesLoading: false,
        allSummariesLoaded: false,
        allSummariesError: action.payload.error,
        allSummariesData: [],
      };

    default:
      return state;
  }
}
